import { faSun } from "@fortawesome/free-regular-svg-icons"
import { faCloud, faCloudMeatball, faCloudRain, faCloudSun, faRainbow, faSun as faSunSolid } from "@fortawesome/free-solid-svg-icons"
import { useUserPreferencesStore } from "src/lib/store"
export const DEFAULT_BATCHTARGET = {
    id: 0,
    name: ""
}

const LINE_1_6 = {
    N: 6,
    PG: 6,
    G: 6,
}
const LINE_3_4 = {
    N: 6,
    PG: 6,
    G: 6,
}
const LINE_2_5 = {
    N: 6,
    PG: 6,
    G: 6,
}
export const WEEKS_OF_CULTURE_BY_LINE = {
    1: LINE_1_6,
    2: LINE_2_5,
    3: LINE_3_4,
    4: LINE_3_4,
    5: LINE_2_5,
    6: LINE_1_6,
}

export const DEFAULT_WEEKS_GRAPH = 2

export const VALUES_INVERTED_SCALE = [
    "fcr"
]

export const COLUMN_AGGREGATIONS = ["avg","sum","best"]

export const AGGREGATED_VALUES_ALIAS = {
    "biomass_year_sum" : "yearlyProduction"
}

/** Used to check that transitions go from 100% old, to 75% old 25% 2days, to 50% 50% 2 days, to 25% 75% 2 days, then 0 100% */
export const FEEDING_TRANSITIONS = [
  [1, 0],
  [0.75, 0.25],
  [0.75, 0.25],
  [0.50, 0.50],
  [0.50, 0.50],
  [0.25, 0.75],
  [0.25, 0.75],
  [0, 1],
]

export const TANK_MONITORED_ACTIONS = ["feeding", "waterBalance", "waterAnalysis", "physicochemicalAnalysis", "biometricAnalysis"];


const _REVIEW_STATE = {
    "1": {
        id: 1,
        name: 'Excellent',
        color: "text-emerald-600 dark:text-emerald-300",
        background: "bg-emerald-600/10 dark:bg-emerald-300/10",
        border: "border-emerald-600 dark:border-emerald-300",
        icon: faSun,
    },
    "2": {
        id: 2,
        name: 'Bon',
        color: "text-blue-500 dark:text-blue-300",
        background: "bg-blue-500/10 dark:bg-blue-300/10",
        border: "border-blue-500 dark:border-blue-300",
        icon: faCloudSun,
    },
    "3": {
        id: 3,
        name: 'Moyen',
        color: "text-amber-500 dark:text-amber-400",
        background: "bg-amber-400/10 dark:bg-amber-400/10",
        border: "border-amber-400 dark:border-amber-400",
        icon: faCloud,
    },
    "4": {
        id: 4,
        name: 'Concernant',
        color: "text-red-500 dark:text-red-400",
        background: "bg-red-400/10 dark:bg-red-400/10",
        border: "border-red-400 dark:border-red-400",
        icon: faCloudRain,
    },
    "5": {
        id: 5,
        name: 'Critique',
        color: "text-violet-400 dark:text-violet-400",
        background: "bg-violet-400/10 dark:bg-violet-400/10",
        border: "border-violet-400 dark:border-violet-400",
        icon: faCloudMeatball,
    }
}

const _REVIEW_STATE_POSITIVE = {
    "1": {
        id: 1,
        name: 'Exceptionnel',
        color: "text-green-600 dark:text-green-300",
        background: "bg-green-600/10 dark:bg-green-300/10",
        border: "border-green-600 dark:border-green-300",
        icon: faRainbow,
    },
    "2": {
        id: 2,
        name: 'Excellent',
        color: "text-teal-500 dark:text-teal-300",
        background: "bg-teal-500/10 dark:bg-teal-300/10",
        border: "border-teal-500 dark:border-teal-300",
        icon: faSunSolid,
    },
    "3": {
        id: 3,
        name: 'Très bon',
        color: "text-sky-500 dark:text-sky-300",
        background: "bg-sky-500/10 dark:bg-sky-300/10",
        border: "border-sky-500 dark:border-sky-300",
        icon: faSun,
    },
    "4": {
        id: 4,
        name: 'Bon',
        color: "text-blue-500 dark:text-blue-300",
        background: "bg-blue-500/10 dark:bg-blue-300/10",
        border: "border-blue-500 dark:border-blue-300",
        icon: faCloudSun,
    },
    "5": {
        id: 5,
        name: 'Moyen',
        color: "text-indigo-500 dark:text-indigo-300",
        background: "bg-indigo-500/10 dark:bg-indigo-300/10",
        border: "border-indigo-500 dark:border-indigo-300",
        icon: faCloud,
    }
}

export const getReviewConfig = () => {
    const positiveMode = useUserPreferencesStore(state => state.positiveMode)
    return positiveMode ? _REVIEW_STATE_POSITIVE : _REVIEW_STATE
};